module.exports = __webpack_public_path__ + "img/skim-pengesahan-bahan-tanaman-2.187392e4.jpeg";